import { MapEntry } from "@mapmycustomers/shared/types/map";

// if address is hidden or masked then region is either not returned at all
// or it contains masked strings instead of numbers inside
const isValidMapEntry = <T extends MapEntry>(entry: T | undefined): entry is T =>
  !!entry && "region" in entry && !!entry.region && typeof entry.region.latitude === "number";

export default isValidMapEntry;
